// extracted by mini-css-extract-plugin
module.exports = {"whyJoin_wrapper":"WhyJoin_whyJoin_wrapper__3SLum","heading":"WhyJoin_heading__3Q4ty","mobileGrid":"WhyJoin_mobileGrid__vFjWI","mobileImage":"WhyJoin_mobileImage__W5jZU"};